// ©2024 Austin App House. All rights reserved.
import React from 'react';
import RowActions from '../../../../../dashboard/RowActions';

const ClientApprovalRow = ({
  customField,
  removeField,
  editField,
}) => (
  <tr>
    <td>{customField.name}</td>
    <td>{customField.required ? 'Yes' : 'No'}</td>
    <td>
      <RowActions
        onEdit={(e) => {
          e.preventDefault();
          editField();
        }}
        onDelete={(e) => {
          e.preventDefault();
          removeField();
        }}
      />
    </td>
  </tr>
);

export default ClientApprovalRow;
